import React, { useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import styled from 'styled-components';
import { TitleText } from '../../../../ui/Text';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface ContractProps {
  url: string;
}

const PeformanceContract = ({ url }: ContractProps) => {
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);

  const documentWrapperRef = useRef<any>();

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <Container ref={documentWrapperRef}>
      {url ? (
        <>
          {' '}
          <Document
            className={'PDFDocument'}
            file={{
              url: url
            }}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            <Page
              width={
                documentWrapperRef.current?.getBoundingClientRect().width ||
                undefined
              }
              className={'PDFPage'}
              pageNumber={pageNumber}
            />
          </Document>
          <Paginantion>
            <button
              onClick={() => setPageNumber(pageNumber - 1)}
              disabled={pageNumber <= 1 ? true : false}
            >
              {'<'}
            </button>
            <button
              onClick={() => setPageNumber(pageNumber + 1)}
              disabled={pageNumber >= numPages ? true : false}
            >
              {'>'}
            </button>
            <span>
              Page{' '}
              <strong>
                {pageNumber} of {numPages}
              </strong>
            </span>
          </Paginantion>
        </>
      ) : (
        <TitleText>No Performance Contract, please upload.</TitleText>
      )}
    </Container>
  );
};

export default PeformanceContract;

const Container = styled.div`
  margin: auto;
  width: 75%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Paginantion = styled.div`
  padding: 0.1em 1em;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  border-radius: 0.5em;
  margin-top: 0.5em;
  button {
    margin: 0.3em;
    cursor: pointer;
    font-weight: bolder;
    background-color: #fff;
    border: none;
    font-size: 1em;
    border-radius: 50%;

    padding: 0.4em;
    align-items: center;
    justify-content: center;
    &:active {
      background-color: #d3d6fe;
      outline: none;
    }
  }
  span {
    margin: 1em;
  }
`;
